import React, { useState, useEffect } from 'react';
import './SoundSettings.css';
import SoundEffects from '../SoundEffects';

function SoundSettings() {
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(0.7); // Default volume 70%
  const [showVolume, setShowVolume] = useState(false);
  
  // Initialize sound settings on component mount
  useEffect(() => {
    // Explicitly set audio as unmuted and set the volume when the component first loads
    SoundEffects.unmute();
    SoundEffects.setMasterVolume(volume);
  }, []);
  
  // Update sound settings when they change
  useEffect(() => {
    if (isMuted) {
      SoundEffects.mute();
    } else {
      SoundEffects.unmute();
      SoundEffects.setMasterVolume(volume);
    }
  }, [isMuted, volume]);
  
  const toggleMute = () => {
    // Toggle mute state
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    
    // Show the volume control temporarily when unmuting
    if (!newMutedState) {
      setShowVolume(true);
      // Hide it after 3 seconds
      setTimeout(() => {
        setShowVolume(false);
      }, 3000);
    }
  };
  
  const handleVolumeClick = () => {
    // Toggle volume control visibility
    setShowVolume(!showVolume);
    
    // If showing the volume, hide after 3 seconds
    if (!showVolume) {
      setTimeout(() => {
        setShowVolume(false);
      }, 3000);
    }
  };
  
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    
    // If changing volume, ensure sounds are not muted
    if (isMuted) {
      setIsMuted(false);
    }
    
    // Play a sound to test the new volume
    if (newVolume > 0) {
      SoundEffects.play('buttonClick');
    }
  };
  
  return (
    <div className="sound-settings">
      <div className="sound-button" onClick={toggleMute}>
        {isMuted ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="1" y1="1" x2="23" y2="23"></line>
            <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path>
            <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path>
            <line x1="12" y1="19" x2="12" y2="23"></line>
            <line x1="8" y1="23" x2="16" y2="23"></line>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" onClick={handleVolumeClick}>
            <path d="M15 8a5 5 0 0 1 0 8"></path>
            <path d="M17.7 5a9 9 0 0 1 0 14"></path>
            <path d="M6 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2l3.5-4.5A.8.8 0 0 1 11 5v14a.8.8 0 0 1-1.5.5L6 15z"></path>
          </svg>
        )}
      </div>
      
      {showVolume && (
        <div className="volume-control">
          <input 
            type="range" 
            min="0" 
            max="1" 
            step="0.1" 
            value={volume}
            onChange={handleVolumeChange}
            className="volume-slider"
          />
        </div>
      )}
    </div>
  );
}

export default SoundSettings;